module.exports = __webpack_public_path__ + "static/00010.445dd605.jpg";